module.exports = __webpack_public_path__ + "images/thumb-40481fee4143d1b05c8ac51d2639e509.jpg";